import { useNavigate, useParams } from "react-router-dom";
import { Button } from "@chuzi/shared/ui";

export function EditorPage() {
  const { storyId } = useParams<{ storyId: string }>();
  const navigate = useNavigate();

  return (
    <div
      style={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        background: "#04070d",
        color: "#e8f0ff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
    >
      <div
        style={{
          maxWidth: 480,
          padding: 24,
          background: "rgba(10,16,32,0.85)",
          border: "1px solid rgba(126,184,255,0.35)",
          borderRadius: 12,
          backdropFilter: "blur(8px)",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>
          Editor
        </div>
        <div
          style={{
            fontSize: 12,
            color: "rgba(232,240,255,0.65)",
            marginBottom: 16,
          }}
        >
          Story <code style={{ color: "#7eb8ff" }}>{storyId}</code> created.
          The editor surface is not built yet.
        </div>
        <Button
          label="Back to my realm"
          variant="ghost"
          onPress={() => navigate("/my", { replace: true })}
        />
      </div>
    </div>
  );
}
